import React from "react";
import PropTypes from "prop-types";
import CompactMetricCard from "src/components/InsightsPage/Cards/CompactMetricCard";

const ManagementOverheadMetric = ({
  metric,
  orgMetric,
  loading,
  targetChanged,
}) => {
  return (
    <CompactMetricCard
      icon={["far", "chart-pie"]}
      title="Management Overhead"
      current={metric.current}
      currentFormatted={metric.currentFormatted}
      target={metric.target}
      targetFormatted={metric.targetFormatted}
      deltaFormatted={metric.deltaFormatted}
      ragStatus={metric.ragStatus}
      loading={loading}
      targetChanged={targetChanged}
      orgManagementOverhead={orgMetric}
    />
  );
};

ManagementOverheadMetric.propTypes = {
  metric: PropTypes.shape({
    current: PropTypes.number,
    currentFormatted: PropTypes.string,
    target: PropTypes.number,
    targetFormatted: PropTypes.string,
    deltaFormatted: PropTypes.string,
    ragStatus: PropTypes.string,
  }).isRequired,
  orgMetric: PropTypes.shape({
    currentFormatted: PropTypes.string,
  }),
  loading: PropTypes.bool,
  targetChanged: PropTypes.bool,
};

export default ManagementOverheadMetric;
